
import { defineComponent, computed } from '@nuxtjs/composition-api';

export default defineComponent({
  props: {
    selectedFilters: {
      type: Array,
      default: () => [],
    },
    item: {
      type: Object,
      default: () => {},
    },
  },
  setup(props, { emit }) {
    const valueLocal = computed({
      get() {
        return props.selectedFilters;
      },
      set(value) {
        emit('filterChanged', value);
      },
    });

    return {
      valueLocal,
    };
  },
});
